import {
  listenTiendas,
  fetchTiendasOnce,
  createTienda as crearTiendaService,
  updateTienda as actualizarTiendaService,
  deleteTienda as eliminarTiendaService,
  TIENDA_FORMATOS,
} from "@/services/firebase/tiendasService";

const initialState = () => ({
  tiendas: [],
  cargando: false,
  error: null,
  cancelarSuscripcion: null,
  formatos: TIENDA_FORMATOS,
});

const state = initialState();

const getters = {
  tiendas: (state) => state.tiendas,
  estaCargando: (state) => state.cargando,
  errorTiendas: (state) => state.error,
  formatosTiendas: (state) => state.formatos,
  tiendasPorFormato: (state) => (formato) => {
    if (!formato) {
      return state.tiendas;
    }
    return state.tiendas.filter((tienda) => tienda.formato === formato);
  },
  tiendaPorDivision: (state) => (division) => {
    if (!division) {
      return null;
    }
    return state.tiendas.find(
      (tienda) => String(tienda.division) === String(division)
    );
  },
};

const mutations = {
  setTiendas(state, tiendas) {
    state.tiendas = tiendas;
  },
  setCargando(state, valor) {
    state.cargando = valor;
  },
  setError(state, error) {
    state.error = error;
  },
  setCancelarSuscripcion(state, fn) {
    state.cancelarSuscripcion = fn;
  },
  limpiarEstado(state) {
    Object.assign(state, initialState());
  },
};

const actions = {
  async iniciarSuscripcion({ commit, state }) {
    if (state.cancelarSuscripcion) {
      return;
    }

    commit("setCargando", true);
    const cancelar = listenTiendas(
      (tiendas) => {
        commit("setTiendas", tiendas);
        commit("setError", null);
        commit("setCargando", false);
      },
      (error) => {
        commit("setError", error);
        commit("setCargando", false);
      }
    );

    commit("setCancelarSuscripcion", cancelar);
  },

  detenerSuscripcion({ state, commit }) {
    if (state.cancelarSuscripcion) {
      state.cancelarSuscripcion();
      commit("setCancelarSuscripcion", null);
    }
  },

  async recargarTiendas({ commit }) {
    commit("setCargando", true);
    try {
      const tiendas = await fetchTiendasOnce();
      commit("setTiendas", tiendas);
      commit("setError", null);
    } catch (error) {
      commit("setError", error);
      throw error;
    } finally {
      commit("setCargando", false);
    }
  },

  async crearTienda({ commit }, payload) {
    commit("setCargando", true);
    try {
      return await crearTiendaService(payload);
    } catch (error) {
      commit("setError", error);
      throw error;
    } finally {
      commit("setCargando", false);
    }
  },

  async actualizarTienda({ commit }, { id, datos }) {
    if (!id) {
      throw new Error("Id de tienda requerido");
    }

    commit("setCargando", true);
    try {
      return await actualizarTiendaService(id, datos);
    } catch (error) {
      commit("setError", error);
      throw error;
    } finally {
      commit("setCargando", false);
    }
  },

  async eliminarTienda({ commit }, id) {
    if (!id) {
      throw new Error("Id de tienda requerido");
    }

    commit("setCargando", true);
    try {
      await eliminarTiendaService(id);
    } catch (error) {
      commit("setError", error);
      throw error;
    } finally {
      commit("setCargando", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

